import React from 'react';
import HeaderLogo from '../../logo/HeaderLogo';
import Offcanvas from 'react-bootstrap/Offcanvas';
import './styles.scss';

const NavigationSidebar = ({ show, onHide, children }) => {
  return (
    <Offcanvas show={show} onHide={onHide} className="courses-navigation-sidebar">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <HeaderLogo />
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default NavigationSidebar;
